import SignalDataSource from './SignalDataSource';
import LastValueDataSource from './LastValueDataSource';
import SignalRDataSource from './SignalRDataSource';
import T from '../../../localization/LocalizationKeys';
import CoordinateSignalDataSource from './CoordinateSignalDataSource';
import PropertyDataSource from './PropertyDataSource';
import PlotlineDataSource from './PlotlineDataSource';
import NodeDataSource from './NodeDataSource';

export const dataSources = {
  signals: {
    source: SignalDataSource,
    label: T.dashboard.panels.dataSource.signals
  },
  coordinateSignals: {
    source: CoordinateSignalDataSource,
    label: 'Selected signals'
  },
  lastValue: {
    source: LastValueDataSource,
    label: T.dashboard.panels.dataSource.lastValue
  },
  realTimeTelemetry: {
    source: SignalRDataSource,
    label: T.dashboard.panels.dataSource.realTime
  },
  properties: {
    source: PropertyDataSource,
    label: 'Properties'
  },
  plotlines: {
    source: PlotlineDataSource,
    label: 'Plotlines'
  },
  nodes: {
    source: NodeDataSource,
    label: 'Nodes'
  }
};

export default dataSources;
